import { useStoreState } from '../../../../store/hooks'
import StreakIndicator from '../../components/StreakIndicator'

const DailyPuzzleStreak: React.FC = () => {
    const streak = useStoreState((state) => state.dailyPuzzleViewV2.streak)
    const puzzleId = useStoreState((state) => state.dailyPuzzleViewV2.puzzleId)

    return (
        <StreakIndicator
            active={streak.currentPuzzleResolved}
            currentStreak={streak.currentStreak}
            variant="daily"
            dataReadySignal={puzzleId}
        />
    )
}

export default DailyPuzzleStreak
